var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 9C6.6 8.25234 7.06641 7.61484 7.52812 6.97969C7.65 6.81328 7.77187 6.64687 7.88906 6.47813C8.35313 5.81016 8.625 5.00156 8.625 4.12734C8.625 1.84687 6.77812 0 4.5 0C2.22187 0 0.375 1.84687 0.375 4.125C0.375 4.99922 0.646875 5.81016 1.11094 6.47578C1.22812 6.64453 1.35 6.81094 1.47187 6.97734C1.93594 7.6125 2.40234 8.25234 2.625 8.99766H6.375V9ZM4.5 12C5.53594 12 6.375 11.1609 6.375 10.125V9.75H2.625V10.125C2.625 11.1609 3.46406 12 4.5 12ZM2.625 4.125C2.625 4.33125 2.45625 4.5 2.25 4.5Cnan nan 1.875 4.33125 1.875 4.125C1.875 2.67422 3.04922 1.5 4.5 1.5C4.70625 1.5 4.875 1.66875 4.875 1.875Cnan nan 4.70625 2.25 4.5 2.25C3.46406 2.25 2.625 3.08906 2.625 4.125Z",
    fill: "#EAB308"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlub);
export default __webpack_public_path__ + "static/media/ic_plub.5f2702cec4d4dc194d91d9ed01bfa3ca.svg";
export { ForwardRef as ReactComponent };